import { Controller } from "stimulus"

export default class extends Controller {
  async toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    const button = this.element;
    if (button.disabled) return;
    const saved = button.getAttribute('aria-pressed') !== 'true';
    button.disabled = true;
    try {
      const response = await fetch(button.dataset.wishlistUrl, {
        method: 'PUT', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content},
        body: JSON.stringify({saved})
      });
      if (!response.ok) throw new Error('Wishlist save failed');
      const result = await response.json();
      document.querySelectorAll('[data-wishlist-uuid]').forEach(heart => {
        if (heart.dataset.wishlistUuid !== button.dataset.wishlistUuid) return;
        heart.setAttribute('aria-pressed', String(result.saved));
        heart.classList.toggle('is-saved', result.saved);
        const label = result.saved ? heart.dataset.removeLabel : heart.dataset.addLabel;
        heart.setAttribute('aria-label', label);
        heart.title = label;
        heart.querySelector('.wishlist-heart-icon').innerHTML = `<i class="${result.saved ? 'fa-solid' : 'fa-regular'} fa-heart" aria-hidden="true"></i>`;
      });
      document.querySelectorAll('.wishlist-count').forEach(count => {
        count.textContent = result.count;
        count.classList.toggle('is-hidden', result.count === 0);
      });
      document.querySelectorAll('[data-action="cart#addWishlist"]').forEach(button => { button.disabled = result.count === 0; });
      const card = button.closest('[data-wishlist-card]');
      if (card && !result.saved) {
        card.remove();
        if (!document.querySelector('[data-wishlist-card]')) document.querySelector('.wishlist-empty').classList.remove('is-hidden');
      }
    } catch (error) {
      window.alert(button.dataset.errorLabel);
    } finally {
      button.disabled = false;
    }
  }
}
